import React, { Component } from 'react';
import styled from 'styled-components';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, SideColumnLeftLarge, MainColumn, Figure, KeySection } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { HeadingH1, HeadingH2, DropCap, BulletedList } from '../../theme/typography';
import { Overlay, OverlayContainer, OverlayFooter } from '../../theme/overlay';
import Header from '../../components/Header/Header';
import PageFooter from '../../components/PageFooter/PageFooter';

const small = require('../../assets/Mozilla/DesignTokens/mozilla-tokens.png');
const medium = require('../../assets/Mozilla/DesignTokens/mozilla-tokens@2x.png');
const large = require('../../assets/Mozilla/DesignTokens/mozilla-tokens@3x.png');

const MozillaIllo = () => (
  <img src={small} srcSet={`${small} 300w, ${medium} 768w, ${large} 1280w`} alt=""/>
);

export default class MozillaSketchPlugin extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
  }

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
      
          <Header theme={"mozilla " + this.state.messageShown} color="#FF0900" date="Summer 2018" role="Concept & Development" action={this.handler}></Header>
          <Article className={"mozilla " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="mozilla">Mozilla</HeadingH2>
                  <HeadingH1>Sketch Plugin</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>S</DropCap>ketch is the main design tool used by product designers at Mozilla. One of the reasons our design team decided to use Sketch over other products, is because Sketch has a large library of plugins. These plugins are created by third-party developers to extend Sketch’s functionality. While at Mozilla I created our own custom Sketch plugin to improve our teams design process.</p>
                  <p>One of the key aspects of my job at Mozilla was to introduce elements of our new branding system to our apps and websites. A big part of this initiative was the creation of design tokens which would act as a single source of truth for developers across several teams and products at the company. Design tokens are the small level design decisions (fonts, colors, etc.) which are used to maintain brand consistency when creating an app/ website. </p>
                </MainColumn>
              </FirstSection>
              <KeySection className={this.state.messageShown}>
                <Figure>
                  <img alt="" src={require('../../assets/Mozilla/SketchPlugin/sketch.gif')} width="100%" />
                </Figure>
              </KeySection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Building a Plugin</h2>
                  <p>I wanted designers to have access to those same design tokens that our developers were using when creating mock-ups in Sketch. There were a couple of existing plugins that I considered using, but none of them met the specific needs of our team.</p>
                  <p>Because we were in the middle of redesigning the Firefox brand our design tokens were constantly changing. We were negotiating for certain font licenses, iterating on color choices, and adding new things to the system almost every single day. There was never a moment were a design decision wasn’t being updated. Most existing plugins required designers to re-upload a json file every single time a design decision changes. Those plugins also gave you no indication when a file was out of date. If we had gone with an existing plugin, we would’ve only added to the confusion that some designers were already facing with the re-branding.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Features</h2>
                  <p>I decided to build our own plugin because we couldn’t find a tool that solved all of our needs. By creating something from scratch we could focus on and alleviate some of the specific problems of our team was facing by introducing a few key features.</p>
                  <BulletedList>
                    <li>
                      <b>Imports Layer Styles</b>
                      <p>Layer styles can be added to any Sketch file by selecting the brand library from the plugin's dropdown menu.</p>
                    </li>
                    <li>
                      <b>Interchangable Layer Styles</b>
                      <p>You change the layer styles from one brand to another by selecting a different brand library from the plugin menu.</p>
                    </li>
                    <li>
                      <b>Updates Layer Fills</b>
                      <p>The document color fills and gradient fills are also updated to match the selected brand library.</p>
                    </li>
                    <li>
                      <b>Works with Design Tokens</b>
                      <p>The plugin was built using Mozilla's design tokens. Ensuring that designers and developers are working with the same design variables.</p>
                    </li>
                    <li>
                      <b>Updates via Appcast</b>
                      <p>Updates are automatically distributed to everyone who has download the sketch plugin. A notification appears in Sketch whenever an update is available.</p>
                    </li>
                  </BulletedList>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <img alt="" style={{boxShadow: 'none'}} src={require('../../assets/Mozilla/SketchPlugin/sketch-preferences@2x.png')} width="100%" />
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Conclusion</h2>
                  <p>The plugin took roughly two weeks to complete. After it was finished I presented the plugin to the rest of the design team, helped people install the plugin, and explained how the plugin works. It was an immediate success and used extensively for several months.</p>
                  <p>When building the plugin I decided to focus on layer styles and layer fills because it was something that Abstract, our design management tool at the time, wasn't able to synch across files. Eventually Abstract gained that functionality, the Firefox rebranding project came to an end, and I decided to leave to start Skwiz so I ended up recreating those layer styles in Abstract which developers had access to and was easier for individual designers to maintain.</p>
                </MainColumn>
                <SideColumnLeftLarge>
                  <MozillaIllo/>
                </SideColumnLeftLarge>
              </Section>
            </Container>
          </Article>
          <PageFooter present={this.state.messageShown} theme="mozilla" left="Design Tokens" leftLink="mozilla-design-tokens" right="Design System" rightLink="design-system"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/MozillaSketchPlugin/SketchPlugin.js